import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Icon, TableCell, TableRow } from "@tremor/react";
import PropTypes from "prop-types";
import { DeleteModal, TableComponent, TitleTablePage } from "../components";
import { getClients } from "../../store/admin/thunks";
import { Spinner } from "../../ui";
import { MenuLayout } from "../layouts";
import { useNavigate } from "react-router-dom";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useAPI } from "../../hooks";

const headers = [
  "Nombre Completo",
  "Teléfono",
  "Correo",
  "Usuarios con Acceso a la App",
  "RFC",
];

const RowTable = ({
  usersAccessApp,
  name,
  email,
  phone,
  businessName,
  navigate,
  dispatch,
  id,
}) => {
  const { del } = useAPI();
  const [showModal, setModal] = useState(false);

  const goToEdit = () => {
    navigate(`/admin/customer/${id}`);
  };

  //TODO: Do this
  const deleteUser = async () => {
    await del(`/admin-client/${id}`);
    dispatch(getClients());
    closeModalDelete();
  };

  const showModalDelete = () => {
    setModal(true);
  };

  const closeModalDelete = () => {
    setModal(false);
  };

  return (
    <>
      {showModal && (
        <DeleteModal
          information={`${name}`}
          cancelFunction={closeModalDelete}
          confirmFunction={deleteUser}
        />
      )}
      <TableRow>
        <TableCell>{name}</TableCell>
        <TableCell>{phone}</TableCell>
        <TableCell>{email}</TableCell>
        <TableCell>{usersAccessApp.length}</TableCell>
        <TableCell>{businessName}</TableCell>
        <TableCell>
          <Icon variant="solid" icon={PencilSquareIcon} onClick={goToEdit} />
          <Icon
            variant="solid"
            icon={TrashIcon}
            className="ml-1"
            onClick={showModalDelete}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export const UsersTablePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    clients = [],
    hasError,
    messageError,
  } = useSelector((state) => state.admin);
  const tableContent = clients.map((d) => (
    <RowTable key={d.id} {...d} navigate={navigate} dispatch={dispatch} />
  ));
  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);
  return (
    <>
      <MenuLayout hasError={hasError} messageError={messageError}>
        <TitleTablePage
          title="Clientes"
          titleBtn="Nuevo Cliente"
          urlToGo="admin/customer"
        />
        {clients.length > 0 ? (
          <TableComponent
            title="Clientes Registrados"
            tableHeaders={headers}
            showSelectLogs={true}
            showSearchInput={true}
            tableContent={tableContent}
          />
        ) : (
          <Spinner />
        )}
      </MenuLayout>
    </>
  );
};

RowTable.propTypes = {
  businessName: PropTypes.string,
  email: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
  navigate: PropTypes.func,
  phone: PropTypes.string,
  usersAccessApp: PropTypes.array,
  dispatch: PropTypes.func,
};
